import React from "react";
import { styled } from "@mui/system";
import {
  OutlinedInput,
  CircularProgress,
  /* Select,
  MenuItem,
  InputAdornment, */
} from "@mui/material";

const InputSearchWrapper = styled("div")`
  margin: 6px 0 12px;
  position: relative;
  & div {
    background: #fff;
  }
  & .loadSpinner {
    position: absolute;
    right: 16px;
    right: -32px;
    top: 16px;
  }
  & .selector {
    & :focus {
      border: 1px solid ${({ theme }) => theme.palette.primary.main};
    }
    > fieldset {
      border-color: transparent !important;
    }
  }
  & input[type="text"] {
    padding: 16.5px 14px;
    line-height: 23px;
    box-shadow: none;
    border-radius: 4px;
    border: 0px;
    background: none;
    background-color: transparent;
    color: currentColor;
  }
`;

export const EdupixSearch = ({
  query,
  onSearch,
  isLoading = false,
  setFilter,
  filter,
  // filterOptions = [],
  ...props
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
  }
  return (
    <form noValidate autoComplete="off" onSubmit={handleSubmit}>
      <InputSearchWrapper>
        <OutlinedInput
          {...props}
          type="text"
          style={{ paddingRight: "0" }}
          fullWidth
          placeholder="Search resourses"
          value={query}
          onChange={(e) => onSearch(e.target.value)}
          /* endAdornment={
            <InputAdornment position="end">
              <Select
                className="selector"
                labelId="label"
                id="select"
                value={filter}
                onChange={(e) =>
                  e.target.value !== filter ? setFilter(e.target.value) : null
                }
              >
                {filterOptions.map((filterItem) => {
                  return (
                    <MenuItem key={filterItem.value} value={filterItem.value}>
                      {filterItem.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </InputAdornment>
          } */
        />
        {isLoading && (
          <CircularProgress className="loadSpinner" size={25} color="primary" />
        )}
      </InputSearchWrapper>
    </form>
  );
};
// export default React.memo(Search);
export default EdupixSearch;
